import React        from 'react';
import PropTypes    from 'prop-types';

import {useSortable} from '@dnd-kit/sortable';
import {CSS}         from '@dnd-kit/utilities';

import MywebPhotos   from './MywebPhotos';

// MywebPhotos'un sürüklenebilir hali. Sürükleme ref'i MywebPhotos'un kendi kök div'ine
// geçer; araya sarmalayıcı eklenmediği için .room-photo-grid flex düzeni korunur.
const SortableMywebPhotos = ({sortableId, sortableDisabled, ...mywebPhotosProps}) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({id: sortableId, disabled: sortableDisabled});

    return (
        <MywebPhotos
            {...mywebPhotosProps}
            draggable={false}
            innerRef={setNodeRef}
            style={{
                transform: CSS.Transform.toString(transform),
                transition,
                opacity: isDragging ? 0.4 : undefined,
                zIndex: isDragging ? 20 : undefined,
            }}
            showDragHandle={!sortableDisabled}
            dragHandleProps={{...attributes, ...listeners}}
        />
    );
};

SortableMywebPhotos.propTypes = {
    sortableId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    // true ise fotoğraf sürüklenemez ve başkasının üzerine bırakılacağı hedef olmaz
    sortableDisabled: PropTypes.bool,
};

export default SortableMywebPhotos;
